import { Component, ViewChild, OnInit } from '@angular/core';
import { MatTableDataSource, MatTable } from '@angular/material/table';
import { MatPaginator, MatPaginatorIntl } from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';
import { UsuariosService } from '@services/usuarios/usuarios.service';
import { PerfilesService } from '@services/perfiles/perfiles.service';
import { UsuarioData } from 'src/app/common/interfaces/user-login.interface';
import Utils from '@utils/utils';
import { SpinnerService } from 'src/app/components/spinner/spinner.service';
import { ToolsService } from '@services/varios/tools.service';
import { CargaMasivaComponent } from './carga-masiva/carga-masiva.component';
import { MatSort, Sort } from '@angular/material/sort';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { UsuarioComponent } from './usuario.component';

@Component({
  selector: 'app-usuarios',
  templateUrl: './usuarios.component.html',
  styleUrls: ['./usuarios.component.scss'],
})
export class UsuariosComponent implements OnInit {

  isChecked = true;
  public usuarios: UsuarioData[] = [];
  public dataUsuarios: MatTableDataSource<UsuarioData> = {} as MatTableDataSource<UsuarioData>;

  selectedColumn: string = 'todas'; // Columna seleccionada en el mat-select
  filterValue: string = ''; // Valor del input de filtro
  pageSize = 5;

  filtros = [
    { value: 'rundv', text: 'RUT' },
    { value: 'nombres', text: 'NOMBRES' },
    { value: 'apellidoPaterno', text: 'APELLIDO PATERNO' },
    { value: 'apellidoMaterno', text: 'APELLIDO MATERNO' },
    { value: 'nombreUsuario', text: 'NOMBRE USUARIO' },
    { value: 'correoCorporativo', text: 'CORREO CORPORATIVO' },
    { value: 'correoPersonal', text: 'CORREO PERSONAL' },
    { value: 'direccionRegional', text: 'DIRECCIÓN REGIONAL' },
    { value: 'nombrePerfil', text: 'PERFIL' },
    { value: 'unidad', text: 'UNIDAD/JARDÍN' },
    { value: 'cargo', text: 'CARGO' },
    { value: 'region', text: 'REGIÓN' },
    { value: 'comuna', text: 'COMUNA' },
    { value: 'estadoUsuario', text: 'ESTADO' },
  ];

  displayedColumns: string[] = [
    'run',
    'nombres',
    'apellidoPaterno',
    'apellidoMaterno',
    'correoCorporativo',
    'direccionRegional',
    'nombrePerfil',
    'oficina',
    'action',
  ];

  constructor(
    private readonly dialog: MatDialog,
    private readonly usuariosService: UsuariosService,
    private readonly perfilesService: PerfilesService,
    private readonly matPaginatorIntl: MatPaginatorIntl,
    private readonly spinnerService: SpinnerService,
    public readonly toolsService: ToolsService,
    private readonly _liveAnnouncer: LiveAnnouncer
  ) {

    this.dataUsuarios = new MatTableDataSource(this.usuarios);
    this.matPaginatorIntl.itemsPerPageLabel = 'Elementos por página';
    this.matPaginatorIntl.lastPageLabel = 'Última Página';
    this.matPaginatorIntl.nextPageLabel = 'Próxima Página';
    this.matPaginatorIntl.firstPageLabel = 'Primera Página';
    this.matPaginatorIntl.previousPageLabel = 'Página Anterior';
    this.matPaginatorIntl.getRangeLabel = (
      page: number,
      pageSize: number,
      length: number
    ) => {
      if (length === 0 || pageSize === 0) {
        return `0 de ${length}`;
      }
      length = Math.max(length, 0);

      const startIndex = page * pageSize;
      const endIndex =
        startIndex < length
          ? Math.min(startIndex + pageSize, length)
          : startIndex + pageSize;
      return `${startIndex + 1} – ${endIndex} de ${length}`;
    };
  }

  @ViewChild(MatTable, { static: true }) table: MatTable<any> = Object.create(this.usuarios);
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator = Object.create(null);
  @ViewChild(MatSort) sort: MatSort = new MatSort();

  ngAfterViewInit() {
    this.dataUsuarios.sort = this.sort;
  }

  announceSortChange(sortState: Sort) {
    if (sortState.direction) {
      this._liveAnnouncer.announce(`Sorted ${sortState.direction}ending`);
    } else {
      this._liveAnnouncer.announce('Sorting cleared');
    }
  }

  windowSizeItems() {
    let windowSize = window.innerWidth;
    if (windowSize > 3840) {
      this.pageSize = 25;
    } else if (windowSize <= 3840 && windowSize > 2560) {
      this.pageSize = 20;
    } else if (windowSize <= 2560 && windowSize > 1920) {
      this.pageSize = 15;
    } else if (windowSize <= 1920 && windowSize > 1280) {
      this.pageSize = 10;
    } else if (windowSize <= 1280) {
      this.pageSize = 5;
    } 
  }

  async ngOnInit() {
    this.windowSizeItems();
    this.refresh();
  }

  async refresh() {
    let spinnerRef = this.spinnerService.start();
    this.usuarios = await this.usuariosService.getUsuariosService();
    this.dataUsuarios = new MatTableDataSource(this.usuarios);
    this.dataUsuarios.paginator = this.paginator;
    this.dataUsuarios.sort = this.sort;
    this.applyFilter();
    this.spinnerService.stop(spinnerRef);
  }

  exportToExcel() {
    const excelBlob = Utils.exportToExcelSimple(
      this.dataUsuarios.sortData(this.dataUsuarios.filteredData, this.sort),
      this.filtros,
      'USUARIOS'
    );
    const now = new Date();
    const fileName = `Usuarios_${now.getFullYear()}-${(now.getMonth() + 1)
      .toString()
      .padStart(2, '0')}-${now.getDate().toString().padStart(2, '0')}_${now
        .getHours()
        .toString()
        .padStart(2, '0')}-${now.getMinutes().toString().padStart(2, '0')}-${now
          .getSeconds()
          .toString()
          .padStart(2, '0')}.xlsx`;

    const link = document.createElement('a');
    link.href = URL.createObjectURL(excelBlob);
    link.download = fileName;
    link.click();

    /*
    Para subir a un servicio ejemplo
    const now = new Date();
    const fileName = `CarreraDocente_Resumen_${nomRegion}_${now.getFullYear()}-${(now.getMonth() + 1).toString().padStart(2, '0')}-${now.getDate().toString().padStart(2, '0')}_${now.getHours().toString().padStart(2, '0')}-${now.getMinutes().toString().padStart(2, '0')}-${now.getSeconds().toString().padStart(2, '0')}.xlsx`;

    let fileUP = new File([excelBlob], fileName, { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    await this.cargaArchivo(idCierre,"RESUMEN", fileUP);
    */
  }

  applyFilter(): void {
    const filterValueLower = Utils.removeAccentsOfString(this.filterValue).trim().toLowerCase();

    if (this.selectedColumn == 'todas') {
      this.clearFilter();
    } else {
      // Aplicar el filtro a la fuente de datos
      this.dataUsuarios.filterPredicate = (data: any, filter: string) => {
        let columnValue = data[this.selectedColumn].toString().toLowerCase();
        return Utils.removeAccentsOfString(columnValue).includes(Utils.removeAccentsOfString(filter));
      };
    }

    // Forzar a que la fuente de datos filtre nuevamente
    this.dataUsuarios.filter = filterValueLower;
  }

  clearFilter() {
    // Reset the filterPredicate to its default value
    this.dataUsuarios.filterPredicate = this.defaultFilterPredicate;
    this.dataUsuarios.filter = '';
  }

  // Default filter predicate function
  defaultFilterPredicate(data: any, filter: string): boolean {
    const dataStr = Object.keys(data).reduce((currentTerm, key) => {
      // Handle cases where data[key] is null/undefined
      if (data[key] !== null && data[key] !== undefined) {
        return currentTerm + data[key].toString().toLowerCase();
      } else {
        return currentTerm;
      }
    }, '');

    // Transform the filter by converting it to lowercase and removing whitespace
    const transformedFilter = Utils.removeAccentsOfString(filter.trim()).toLowerCase();
    return Utils.removeAccentsOfString(dataStr).indexOf(transformedFilter) !== -1;
  }

  async openDialogCarga(): Promise<void> {
    const dialogRef = this.dialog.open(CargaMasivaComponent, {
      width: '600px',
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe(async (result) => {
      if (result) {
        this.refresh();
      }
    });
  }

  async openDialog(action: string, obj: any): Promise<void> {
    obj.action = action;
    obj.perfiles = await this.perfilesService.getPerfilesUsuario(obj.idUsuario);

    const dialogRef = this.dialog.open(UsuarioComponent, {
      data: obj,
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe(async () => {
        await this.refresh();
    });
  }

  async setEstadoUsuario(row_obj: UsuarioData) {
    let spinnerRef = this.spinnerService.start();

    let estadonuevo: string = row_obj.estadoUsuBool ? 'ACTIVO' : 'INACTIVO';
    row_obj.estadoUsuario = estadonuevo;
    await this.usuariosService.updateEstadoUsuarioSistema(row_obj);

    this.spinnerService.stop(spinnerRef);
  }
}